export default __webpack_public_path__ + "static/logo_white_new-97d5333fa4761c76870a8ac17548e51b.png";